import { authoringRoute } from "../authoring.runtime"
import { Account } from "routes/settings/plugins/account/account"

authoringRoute.register("account", <Account $lazy />)
